import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../lib/api';
import type { ApiKeyDto, ModelRateDto, WorkspaceDto } from '../lib/types';

export function useWorkspaces() {
  return useQuery({ queryKey: ['admin', 'workspaces'], queryFn: () => apiClient.get<WorkspaceDto[]>('/api/admin/workspaces') });
}

export function useApiKeys() {
  return useQuery({ queryKey: ['admin', 'apikeys'], queryFn: () => apiClient.get<ApiKeyDto[]>('/api/admin/apikeys') });
}

export function usePricing() {
  return useQuery({ queryKey: ['admin', 'pricing'], queryFn: () => apiClient.get<ModelRateDto[]>('/api/admin/pricing') });
}

/** Full replacement of the rate table; the next Claude API sync re-prices per-key estimates with it. */
export function useSavePricing() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (rates: ModelRateDto[]) => apiClient.put<ModelRateDto[]>('/api/admin/pricing', { rates }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['admin', 'pricing'] })
  });
}
